import React from 'react'

const ListingContent = props => {
    return <tbody>
    {props.children}
    </tbody>
}

export default ListingContent
